module.exports = __webpack_public_path__ + "static/media/challenge-background-task.a8700f17.svg";